"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrunkTypeEnum = void 0;
var TrunkTypeEnum;
(function (TrunkTypeEnum) {
    TrunkTypeEnum["Connectel"] = "connectel";
    TrunkTypeEnum["Custom"] = "custom";
})(TrunkTypeEnum = exports.TrunkTypeEnum || (exports.TrunkTypeEnum = {}));
